import cx from 'classnames'

import { HeadingS } from '@/legacy/components/Typography'

import type { CountdownStyleProps, CountdownTextColor } from '../types'

import { CountdownDigitsContainer, Digit } from './styles'

interface Props extends Pick<CountdownStyleProps, 'clockBackGround' | 'clockBackGroundHex'> {
  digits: string[]
  className?: string
  clockColor?: CountdownTextColor
}

const Counter = ({ digits, clockBackGround, clockColor, clockBackGroundHex, className }: Props) => (
  <CountdownDigitsContainer className={className}>
    {digits.map((digit, digitIndex) => (
      <Digit
        style={{
          backgroundColor: (clockBackGround === 'custom' && clockBackGroundHex) || undefined,
        }}
        className={cx({
          [`et-bg-${clockBackGround}`]: clockBackGround !== 'custom' && clockBackGround,
        })}
        key={digitIndex}
      >
        <HeadingS {...clockColor} emphasys>
          {digit}
        </HeadingS>
      </Digit>
    ))}
  </CountdownDigitsContainer>
)

export default Counter
